import React from "react";

const LeaveDetailsTables = ({ leaveBalance }) => {
  return (
    <>
      {/* Basic Leaves Detail Table */}
      <table className="mt-8 w-full">
        <thead>
          <tr>
            <th
              colSpan="6"
              className="font-bold py-3 px-4 bg-[color:var(--color1)] text-white"
            >
              Basic Leaves Detail
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="font-bold border py-3 px-4 text-center">In month</td>
            <td className="font-bold border py-3 px-4 text-center">Utilized</td>
            <td className="font-bold border py-3 px-4 text-center">
              Opening Balance
            </td>
            <td className="font-bold border py-3 px-4 text-center">
              Closing Balance
            </td>
            <td className="font-bold border py-3 px-4 text-center">Adj. Add</td>
            <td className="font-bold border py-3 px-4 text-center">Adj. Sub</td>
          </tr>
          <tr>
            <td className="border py-3 px-4 text-center">
              {leaveBalance?.basic_accured_in_month}
            </td>
            <td className="border py-3 px-4 text-center">
              {leaveBalance?.basic_accured_utilised}
            </td>
            <td className="border py-3 px-4 text-center">
              {leaveBalance?.basic_accured_opening_balance}
            </td>
            <td className="border py-3 px-4 text-center">
              {leaveBalance?.basic_accured_closing_balance}
            </td>
            <td className="border py-3 px-4 text-center">
              {leaveBalance?.basic_accured_adj_add}
            </td>
            <td className="border py-3 px-4 text-center">
              {leaveBalance?.basic_accured_adj_sub}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Conditional Holiday OT & Normal OT Details */}
      {leaveBalance?.ot_leave_applicable && (
        <>
          <table className="mt-8 w-full">
            <thead>
              <tr>
                <th
                  colSpan="6"
                  className="font-bold py-3 px-4 bg-[color:var(--color1)] text-white"
                >
                  Holiday OT Detail
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="font-bold border py-3 px-4 text-center">
                  In month
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Utilized
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Opening Balance
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Closing Balance
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Adj. Add
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Adj. Sub
                </td>
              </tr>
              <tr>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.holiday_ot_in_month}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.holiday_ot_utilised}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.holiday_ot_opening_balance}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.holiday_ot_closing_balance}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.holiday_ot_adj_add}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.holiday_ot_adj_sub}
                </td>
              </tr>
            </tbody>
          </table>

          <table className="mt-8 w-full">
            <thead>
              <tr>
                <th
                  colSpan="6"
                  className="font-bold py-3 px-4 bg-[color:var(--color1)] text-white"
                >
                  Normal OT Detail
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="font-bold border py-3 px-4 text-center">
                  In month
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Utilized
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Opening Balance
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Closing Balance
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Adj. Add
                </td>
                <td className="font-bold border py-3 px-4 text-center">
                  Adj. Sub
                </td>
              </tr>
              <tr>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.normal_ot_in_month}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.normal_ot_utilised}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.normal_ot_opening_balance}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.normal_ot_closing_balance}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.normal_ot_adj_add}
                </td>
                <td className="border py-3 px-4 text-center">
                  {leaveBalance?.normal_ot_adj_sub}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </>
  );
};

export default LeaveDetailsTables;
